// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Demo_componentWrapper__iZjTJ"};